import { module } from 'modujs';

const JS_ID   = 'ze-snippet';
const API_URL = 'https://static.zdassets.com/ekr/snippet.js?key=fc9498d6-ff00-42cb-9114-a36daec75206';

let API_LOADED  = null;
let API_LOADING = null;

function hasZE() {
    return (typeof window.zE === 'function');
}

/**
 * Zendesk Web Widget (Classic) Integration
 *
 * @link https://developer.zendesk.com/api-reference/widget/introduction/
 */
export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.addEventListener('modularloading', () => this.hide(), {
            once: true
        });

        if (this.hasAPI()) {
            this.show();
        } else {
            this.loadAPI();
        }
    }

    destroy() {
        this.hide();
    }

    hasAPI() {
        return API_LOADED && hasZE();
    }

    loadAPI() {
        if (
            API_LOADED !== null ||
            API_LOADING ||
            hasZE() ||
            document.getElementById(JS_ID)
        ) {
            return;
        }

        API_LOADING = true;

        const script = document.createElement('script');

        script.id  = JS_ID;
        script.src = API_URL;

        script.onload  = () => {
            API_LOADED  = true;
            API_LOADING = false;
        };
        script.onerror = () => {
            API_LOADED  = false;
            API_LOADING = false;
        };

        document.body.appendChild(script);
    }

    hide() {
        if (this.hasAPI()) {
            window.zE?.('webWidget', 'hide');
        }
    }

    show() {
        if (this.hasAPI()) {
            window.zE?.('webWidget', 'show');
        }
    }
}
